import * as React from 'react';
import { PerguntaData } from './FetchPergunta';
import { Resource } from '../../../index';
import { LanguageContext } from '../../../context/LanguageContext';
import {
    HelpCircle,
    Info,
    Eye,
    PenTool,
    Paperclip,
    CheckCircle2,
    XCircle,
    ListChecks,
    Camera,
    List
} from 'lucide-react';

interface VisualizacaoDetalhadaPerguntaProps {
    pergunta: PerguntaData;
}

export class VisualizacaoDetalhadaPergunta extends React.Component<VisualizacaoDetalhadaPerguntaProps, any> {
    static contextType = LanguageContext;

    render() {
        const { pergunta } = this.props;

        return (
            <div className="card shadow-sm mb-3" style={{ borderRadius: '12px', border: '1px solid #e0e0e0' }}>
                <div className="card-body p-4">
                    <div className='d-flex align-items-start'>
                        <div style={{ minWidth: '1.5rem' }} className="mr-2">
                            <HelpCircle className="text-primary" size="1.5rem" />
                        </div>
                        <div>
                            <h5 className="card-title text-dark font-weight-bold mb-3">
                                {pergunta.titulo}
                            </h5>
                        </div>
                    </div>

                    {pergunta.descricao && (
                        <p className="card-text text-muted mb-3 pl-4" style={{ borderLeft: '3px solid #007bff', paddingLeft: '10px' }}>
                            {pergunta.descricao}
                        </p>
                    )}

                    {pergunta.ajuda && (
                        <div className="alert alert-secondary p-2 mb-4 d-flex align-items-center" role="alert" style={{ fontSize: '0.9rem', borderRadius: '8px' }}>
                            <Info className="mr-2 text-info" size={20} />
                            <div>
                                <strong><Resource keyString="help" />:</strong> {pergunta.ajuda}
                            </div>
                        </div>
                    )}

                    <div className="row mb-4">
                        <div className="col-md-6">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2 border-0">
                                    <span className="d-flex align-items-center"><Eye className="mr-2 text-muted" size={18} /><Resource keyString="allow_observation" /></span>
                                    {pergunta.permitirobservacao ? <CheckCircle2 className="text-success" size={20} /> : <XCircle className="text-danger" size={20} />}
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2 border-0">
                                    <span className="d-flex align-items-center"><PenTool className="mr-2 text-muted" size={18} /><Resource keyString="allow_annotation" /></span>
                                    {pergunta.permitiranotacao ? <CheckCircle2 className="text-success" size={20} /> : <XCircle className="text-danger" size={20} />}
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2 border-0">
                                    <span className="d-flex align-items-center"><Paperclip className="mr-2 text-muted" size={18} /><Resource keyString="allow_attach_evidence" /></span>
                                    {pergunta.permitiranexarevidencia ? <CheckCircle2 className="text-success" size={20} /> : <XCircle className="text-danger" size={20} />}
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2 border-0">
                                    <span className="d-flex align-items-center"><ListChecks className="mr-2 text-muted" size={18} /><Resource keyString="allow_create_action" /></span>
                                    {pergunta.permitircriaracao ? <CheckCircle2 className="text-success" size={20} /> : <XCircle className="text-danger" size={20} />}
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2 border-0">
                                    <span className="d-flex align-items-center"><Camera className="mr-2 text-muted" size={18} />Permitir Anexar Foto Pelo Aplicativo</span>
                                    {pergunta.permitiranexarfotoapp ? <CheckCircle2 className="text-success" size={20} /> : <XCircle className="text-danger" size={20} />}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-2 pt-3 border-top">
                        <h6 className="font-weight-bold text-dark mb-3 d-flex align-items-center"><List className="mr-2" size={20} />Respostas:</h6>
                        <div className="d-flex flex-wrap">
                            {pergunta.respostas && pergunta.respostas.length > 0 ? (
                                pergunta.respostas.map((resposta, index) => (
                                    <span key={index} className="badge badge-pill badge-light border mr-2 mb-2 px-3 py-2" style={{ fontSize: '0.9rem', color: '#555' }}>
                                        {resposta.nome}
                                    </span>
                                ))
                            ) : (
                                <span className="text-muted font-italic ml-2"><small><Resource keyString="no_answers_registered" /></small></span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
